export enum WageType {
  Earned = 0,
  EarnedAndDay = 1,
  EarnedAndWeek = 2,
  EarnedAndDayAndWeek = 3,
  EarnedOrDay = 4,
  EarnedOrWeek = 5,
  None = 6,
  EarnedOrDayAvg = 7,
  DayOnly = 11,
  DayWithThreshold = 17,
  WeekOnly = 12,
  DayAndWeek = 13,
  LhDayPlusSpots = 14,
  HrSpSoDayPlusTeamMiles = 15,
  SpotDayPlusLh = 16,
  HoursOnly = 18,
  HoursWithThresholds = 19,
  EarnedNoMileageAndDay = 20,
  EarnedNoMileageAndWeek = 21,
  EarnedOrDayPlusTeamMiles = 22,
  EarnedWithDayThreshold = 23,
  NoMileage = 24,
  NoMileageAndWeek = 25,
  EarnedNoMileageOrDay = 26,
  HrOrDaysPlusTeamMiles = 27,
  HrPlusTeamDays = 28
}

export const WageTypeMapping: Record<WageType, string> = {
  [WageType.Earned]: 'Earned',
  [WageType.EarnedAndDay]: 'Earned + Daily',
  [WageType.EarnedAndWeek]: 'Earned + Weekly',
  [WageType.EarnedAndDayAndWeek]: 'Earned + Daily + Weekly',
  [WageType.EarnedOrDay]: 'Earned Or Daily',
  [WageType.EarnedOrDayAvg]: 'Earned Or Daily Avg',
  [WageType.EarnedOrWeek]: 'Earned Or Weekly',
  [WageType.None]: 'None',
  [WageType.DayOnly]: 'Daily Pay',
  [WageType.DayWithThreshold]: 'Daily Pay + Threshold',
  [WageType.WeekOnly]: 'Weekly Pay',
  [WageType.DayAndWeek]: 'Daily + Weekly',
  [WageType.LhDayPlusSpots]: 'LH Day + Spots',
  [WageType.SpotDayPlusLh]: 'Spot Day + LH',
  [WageType.HrSpSoDayPlusTeamMiles]: 'Hr/Solo/Spots Day + Team Miles',
  [WageType.HoursOnly]: 'Hours Only',
  [WageType.EarnedNoMileageAndDay]: 'Daily + Non-Mileage',
  [WageType.EarnedNoMileageAndWeek]: 'Week + Non-Mileage',
  [WageType.EarnedOrDayPlusTeamMiles]: 'Hr/Solo/Spots or Day + Team Miles',
  [WageType.EarnedWithDayThreshold]: 'Earned + Day Threshold',
  [WageType.HoursWithThresholds]: 'Hours with Thresholds',
  [WageType.NoMileage]: 'Non-Miles',
  [WageType.NoMileageAndWeek]: 'Non-Miles + Week',
  [WageType.EarnedNoMileageOrDay]: 'Non-Mileage or Day',
  [WageType.HrOrDaysPlusTeamMiles]: 'Hours or Days + Team Miles',
  [WageType.HrPlusTeamDays]: 'Hours + Team Days'
};
